import { logUsage } from 'owa-analytics';
import { action } from 'satcheljs/lib/legacy';
import { putGetStartedTask } from '../services/putGetStartedTask';
import { GetStartedTaskId } from '../enums/GetStartedTaskId';
import { GetStartedTaskStatus } from '../enums/GetStartedTaskStatus';
import { getStore } from '../store/store';

export default action('completeGetStartedTask')(async function completeGetStartedTask(
    identity: GetStartedTaskId
) {
    const store = getStore();
    const task = store.tasks[identity];

    if (task.status === GetStartedTaskStatus.Pending) {
        logUsage('GetStartedTaskCompleted', [identity, task.clicked], { isCore: true });

        // Complete the task, add it to the completed task dictionary, and remove it
        // from pending task dictionary
        task.status = GetStartedTaskStatus.Completed;

        // Update server to record the state
        await putGetStartedTask(identity);
    }
});
